import React from "react";
import { Card, Input, Button } from "@nextui-org/react";
import { motion } from "framer-motion";

const MotionButton = motion(Button);
const btnAnim = { whileTap: { scale: 0.9 } };

const AltEntriesFilterCard = ({
  search,
  onSearchChange,
  viewBy,
  onViewByChange,
  allChecked,
  onToggleAll,
  showSubs = true,
}) => {
  return (
    <motion.div className="qtyContainer alignDivCenter">
      <Card variant="bordered" css={{ mw: "550px" }}>
        <Card.Body className="reportDate" css={{ py: "10px" }}>
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                padding: "0 12px",
                height: "40px",
                backgroundColor: "#f1f3f5",
                borderRadius: "12px",
                border: "1px solid #e0e0e0",
                cursor: "pointer",
                userSelect: "none",
                flexShrink: 0,
              }}
              onClick={() => onToggleAll?.(allChecked !== true)}
            >
              <input
                type="checkbox"
                id="selectAllCheckbox"
                checked={allChecked === true}
                ref={(el) => {
                  if (el) el.indeterminate = allChecked === "indeterminate";
                }}
                onChange={(e) => {
                  e.stopPropagation();
                  onToggleAll?.(e.target.checked);
                }}
                style={{
                  width: "18px",
                  height: "18px",
                  cursor: "pointer",
                  accentColor: "#ff385c",
                }}
              />
              <label
                htmlFor="selectAllCheckbox"
                style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                All
              </label>
            </div>

            <Input
              fullWidth
              aria-label="Search"
              placeholder="Search phone, customer, issue, note..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              clearable
              css={{ flex: 1 }}
            />
          </div>
        </Card.Body>
        <Card.Divider />
        <Card.Footer
          css={{
            display: "inline-flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 6,
          }}
        >
          <MotionButton
            size="sm"
            auto
            color={viewBy === "all" ? "primary" : "secondary"}
            onClick={() => onViewByChange("all")}
            {...btnAnim}
          >
            All
          </MotionButton>
          <MotionButton
            size="sm"
            auto
            color={viewBy === "shop" ? "primary" : "secondary"}
            onClick={() => onViewByChange("shop")}
            {...btnAnim}
          >
            Shop
          </MotionButton>
          <MotionButton
            size="sm"
            auto
            color={viewBy === "customer" ? "primary" : "secondary"}
            onClick={() => onViewByChange("customer")}
            {...btnAnim}
          >
            Customer
          </MotionButton>
          {showSubs && (
            <MotionButton
              size="sm"
              auto
              color={viewBy === "deductions" ? "primary" : "secondary"}
              onClick={() => onViewByChange("deductions")}
              {...btnAnim}
            >
              Subs
            </MotionButton>
          )}
        </Card.Footer>
      </Card>
    </motion.div>
  );
};

export default AltEntriesFilterCard;
